//
//
//
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "img",
  computed: {
    styleImgName: function styleImgName() {
      var _this = this;

      return Object.assign(function () {
        if (_this.rotate) {
          return {
            animationDuration: _this.duration / 1000 + "s"
          };
        }

        return {};
      }(), {
        width: '100%',
        height: '100%',
        opacity: this.option.opacity || 1
      });
    },
    duration: function duration() {
      return this.option.duration || 3000;
    },
    rotate: function rotate() {
      return this.option.rotate;
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.clickFormatter && this.clickFormatter({
        data: this.dataChart
      }, this.getItemRefs());
    }
  }
});